import { RouterProvider } from 'react-router-dom';

import { getMaintenanceStatus, useConfigStore } from '@packages/stores';

import { Maintenance, ModalNavigator } from '@components';
import ErrorBoundary from '@components/errorBoundary/errorBoundary.component';
import { useGuestSubscription } from '@hooks';
import { router } from '@routes/router';
import { initSentry } from '@utils';

import remoteConfig from '../remoteSettings.json';
import './utils/amplifyConfigure';

initSentry();

useConfigStore.getState().setConfig(remoteConfig);

export const App = () => {
  useGuestSubscription();
  const isUnderMaintenance = useConfigStore(getMaintenanceStatus);
  let content = (
    <>
      <RouterProvider router={router} />
      <ModalNavigator />
    </>
  );

  if (isUnderMaintenance) {
    content = <Maintenance />;
  }

  return <ErrorBoundary>{content}</ErrorBoundary>;
};
